import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import usePaymentConditionService from '../../../app/services/hooks/usePaymentConditionService';
import {
    PaymentConditionDataForm,
    defaultPaymentConditionDataForm
} from '../../../app/models/PaymentCondition';
import PaymentConditionForm from './forms/PaymentConditionForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    paymentConditionId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PaymentConditionEdit = ({
    paymentConditionId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const {
        fetchingEditPaymentCondition,
        editPaymentCondition,
        fetchingUpdatePaymentCondition,
        updatePaymentCondition
    } = usePaymentConditionService();
    const [paymentCondition, setPaymentCondition] = useState<PaymentConditionDataForm>(
        defaultPaymentConditionDataForm
    );
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando condición de pago...');
        editPaymentCondition(paymentConditionId, {
            onSuccess: (response: ServiceResponse) => {
                setPaymentCondition(response.data.payment_condition);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando condición de pago...');
        updatePaymentCondition(paymentConditionId, paymentCondition, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditPaymentCondition ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <PaymentConditionForm
                        paymentConditionDataForm={paymentCondition}
                        setPaymentConditionDataForm={setPaymentCondition}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingUpdatePaymentCondition}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm
                        callbackSave={update}
                        locked={fetchingUpdatePaymentCondition}
                    />
                </div>
            </div>
        </>
    );
};

export default PaymentConditionEdit;
